import { useState } from 'react';
import { toast } from 'sonner';
import downloadBlob from '../../../../../../Overview/Contexts/CandidatesTableContext/utils/downloadBlob';
import { useCandidatesResultsContext } from '../../../../../Contexts/CandidateResultsContext';
import BodyTypography from '../../../../Common/BodyTypography';
import DownloadButton from '../../../../Common/DownloadButton';
import GridRowNode from '../Common/GridRowNode';
import getCvIcon from './Utils/getCvIcon';
import ApplicantInformation from '@/Models/ApplicantInformation';
import UIStrings from '@/Utils/UIStrings';

interface ApplicantCvSectionProps {
    cv: ApplicantInformation;
}

function ApplicantCvSection({ cv }: ApplicantCvSectionProps) {
    const { results, downloadCvAsync } = useCandidatesResultsContext();
    const { candidateFirstName, candidateLastName } = results;
    // cv.answer is file extension
    const pdfFileName = UIStrings.FormFileName(`${candidateFirstName} ${candidateLastName}`, UIStrings.CV, cv.answer);
    const [isCvDownloading, setIsCvDownloading] = useState<boolean>(false);

    const onClickHandler = async () => {
        try {
            setIsCvDownloading(true);
            const { blob } = await downloadCvAsync();
            downloadBlob(pdfFileName, blob);
            toast.success(UIStrings.DownloadSuccessful, {
                description: UIStrings.CvHasBeenDownloadedSuccessfully,
            });
        } catch {
            toast.error(UIStrings.DownloadFailed, {
                description: UIStrings.SorryWeWereUnableToDownloadCv,
            });
        } finally {
            setIsCvDownloading(false);
        }
    };

    return (
        <GridRowNode
            title={<BodyTypography>{UIStrings.CurriculumVitae}:</BodyTypography>}
            node={
                <div className="border-border flex w-fit items-center gap-6 rounded-md border p-2.5">
                    <div className="flex items-center gap-1.5">
                        {getCvIcon(cv.answer)}
                        <p className="text-foreground text-sm">{pdfFileName}</p>
                    </div>
                    <DownloadButton onClick={onClickHandler} label={UIStrings.DownloadCv} loading={isCvDownloading} />
                </div>
            }
        />
    );
}

export default ApplicantCvSection;
